import { createContext, useContext } from "react";

const RecurringTaskContext = createContext({});

export const RecurringTaskContextProvider = RecurringTaskContext.Provider;
export const RecurringTaskContextConsumer = RecurringTaskContext.Consumer;

export const useRecurringTaskContext = () => useContext(RecurringTaskContext);

export default RecurringTaskContext;
